import getVariantPayload from '@/utils/getVariantPayload';

/**
 * Find the variant that matches the selected option value plus the ones in the
 *  currently selected variant.
 * @param productData - The contentstack product object
 * @param selectedVariant - The currently selected variant (either payload or
 *   shopify variant works here actually)
 * @param optionValue - The value of the option we want to match
 * @returns The new variant that matches the selected option
 */
export function getMatchingVariant(productData, selectedVariant, optionValue) {
  const shopifyProduct = productData.shopifyProduct;

  // Find the option name by looking for the first option that matches the
  // clicked option value.
  const optionName = shopifyProduct.options.find((option) => {
    return option.values.find((v) => v === optionValue);
  })?.name;
  if (optionName) {
    // Find the new variant that matches the selected option
    const newVariant = shopifyProduct.variants.find((variant) => {
      const newOptions = selectedVariant.selectedOptions.map((option) => {
        if (option.name === optionName) {
          return { ...option, value: optionValue };
        }
        return option;
      });
      return variant.selectedOptions.every((option) => {
        return newOptions.some(({ name, value }) => {
          return name === option.name && value === option.value;
        });
      });
    });

    if (newVariant) {
      const payload = getVariantPayload({
        variant: newVariant,
        shopifyProduct: shopifyProduct,
        productData
      });

      return payload;
    } else {
      throw new Error(`No variant found for ${optionValue}.`);
    }
  } else {
    throw new Error(
      `No option name found for ${optionValue}. Please double check settings.`
    );
  }
}
